<template>
  <GDialog :id ref="dialog" @click-out="emits('clickOut')">
    <slot></slot>
  </GDialog>
</template>

<script setup>
const id = useId();

const emits = defineEmits(["clickOut"]);

const dialog = useTemplateRef("dialog");
const snackbar = useSnackbar();
const appStore = useAppStore();

let oldTeleport = null;

const dialogId = computed(() => `#${id}`);

defineExpose({
  showModal: () => {
    snackbar.closeAll();
    oldTeleport = appStore.teleport;
    dialog.value?.showModal();
    appStore.teleport = dialogId.value;
  },
  close: () => {
    snackbar.closeAll();
    dialog.value?.close();
    appStore.teleport = oldTeleport;
  },
  customElement: () => dialog.value.customElement(),
});
</script>
